// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"346":"fb485dff","595":"0e7f7860","690":"4849da70","979":"2733f872"}[chunkId] + ".chunk.css";
};